module.exports = __webpack_public_path__ + "img/arrobita_think.99c0f57a.png";